import { Component, OnInit } from '@angular/core';
import { FormControl, FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { onlinesmsservices } from '../../../services/onlinesms.services';

import { smssubmitcode } from '../../../models/onlinesms.models/smssubmitcode';
import { error } from 'protractor';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'onlineAnsweringSmscomponet',
  templateUrl: 'onlineAnsweringSms.componet.html'
})
export
  class onlineAnsweringSmscomponet implements OnInit {
  //ListTest: any = [];
  //SelectedTestList: any = [];
  //testAcceptionFormModel: FormGroup;
  //formSaved: boolean = false;
  //savedFormData: any = {};
  //paymentUrl: string = '';
  sucsses: boolean;
  approved: boolean;
  waiting: boolean;
  approvedList: any = [];



  ngOnInit(): void {
    //this.admissionOfCoronaryPatientscomponentservices.GetStatusAnswer(1)
    //  .subscribe((data: TestCost[]) => {
    //    this.ListTest = data
    //  });
    this.sucsses = false;
    this.approved = false;
    this.waiting = false;

    this.route.params.subscribe(p => {
      this.SmsCode.setValue(p.code);
      this.PersonMobile.setValue(p.phone);

      this.Submitform();
    });
  }


  SmsCode: FormControl = new FormControl();
  PersonMobile: FormControl = new FormControl();

  phoneform: FormGroup = this.formBuilder.group({
    PersonMobile: this.PersonMobile
  });


  smsform: FormGroup = this.formBuilder.group({
    SmsCode: this.SmsCode
  });


  constructor(private formBuilder: FormBuilder, private onlinesmsservices: onlinesmsservices, private route: ActivatedRoute, private router: Router) { }

  Submitformphone() {
    this.waiting = true;
    this.onlinesmsservices.Getcode(this.PersonMobile.value).subscribe(resp => {

      this.waiting = false;
      this.sucsses = true;
      alert(resp);

    }, (err) => {
      this.waiting = false;
      this.sucsses = false;
      console.error(err);
      alert(err);
    });
  }
  Submitform() {
    this.waiting = true;
    this.onlinesmsservices.GetAnswering(this.PersonMobile.value, this.SmsCode.value).subscribe(resp => {
      this.waiting = false;
      this.approved = true;
      console.log('list: ', resp);
      this.approvedList = resp;
    }, (err) => {
      debugger;
      this.waiting = false;
      console.error(err);
      alert(err.error);
      this.router.navigateByUrl('/OnlineAnswering');
    });
  }
  goToMilestone(item) {
    ///check-answer/{{item.fCodeMonth}}/{{PersonMobile.value}}
    this.router.navigateByUrl(`/check-answer/${item.fCodeMonth}/${this.PersonMobile.value}`);
  }
  
}
